import { render, staticRenderFns } from "./ScrollHorizontal.vue?vue&type=template&id=8e18821a&scoped=true&lang=pug&"
import script from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
export * from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ScrollHorizontal.vue?vue&type=style&index=0&id=8e18821a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e18821a",
  null
  
)

export default component.exports